import { Reducer } from 'redux';

const initialState = { ready: false };

type State = typeof initialState;

export const STORE_LOADED = 'STORE_LOADED';

export const storeLoaded = (data: any) => ({ type: STORE_LOADED, data }) as const;

type Action = ReturnType<typeof storeLoaded>;

// no actions handled by reducer, see deserialization and STORE_LOADED
const storeService: Reducer<State, Action> = (state = initialState) => state;

export default storeService;
